module.exports = __webpack_public_path__ + "img/md-chart.aa68d999.png";